/* ============================================================================
   master-bmsm-v3.js
   SHARED runtime JS for the Master BMSM (Buy More Save More) sections.
   NOTE: "v3" here means the 3rd iteration of THIS script. It is NOT the JS
   of the Master BMSM V3 section (that section is self-contained, inline JS).

   Loaded (defer) by:
     - sections/master-buy-more-save-more.liquid      V1: original build, used
       on the first two landing pages (Invisible Lift and Plunge)
     - sections/master-buy-more-save-more-v2.liquid   V2: per-pair pricing,
       works with most bundle products (Invisible Lift, Plunge, Demi Boost)
     - sections/master-buy-more-save-more-v2-1.liquid V2.1: per-pair clone for
       the Comfy Bra (real Size/Type/Color options, no pack-size variant)

   Product-agnostic: builds the pack-size map from variant Option 3
   ("1 Pair" / "2 Packs" / ...) and auto-adapts to the option wording.
   ============================================================================ */

(function() {
  var sectionEl = document.querySelector('.hdt-master-buy-more-save-more-section');
  if (!sectionEl) return;

  var sectionId = sectionEl.dataset.sectionId;
  var variantsScript = document.getElementById('master-bmsm-product-variants-' + sectionId);
  if (!variantsScript) return;
  var variantsData = [];
  try { variantsData = JSON.parse(variantsScript.textContent); } catch (e) {}

  /* Build qty number → option3 value map (e.g. 1 → "1 Pack", 2 → "2 Packs"). Auto-adapts to "Pair", "Pack", "Set", etc. */
  var qtyOptionMap = {};
  variantsData.forEach(function(v) {
    if (!v.options || v.options.length < 3) return;
    var val = v.options[2];
    if (!val) return;
    var num = parseInt(String(val).split(' ')[0], 10);
    if (num && !qtyOptionMap[num]) qtyOptionMap[num] = val;
  });
  function qtyOption(n) {
    return qtyOptionMap[n] || (n === 1 ? '1 Pair' : n + ' Pairs');
  }

  /* ── Helpers ── */
  function getSelectedColor() {
    var radio = sectionEl.querySelector('fieldset.is-style-color input[type="radio"]:checked');
    if (radio) return radio.value;
    var label = sectionEl.querySelector('fieldset.is-style-color [update-value]');
    return label ? label.textContent.trim() : '';
  }

  function getSelectedSize() {
    var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
    return sizeInput ? sizeInput.value : '';
  }

  function findVariantByOptions(opts) {
    // opts: array of values, in option1/option2/option3 order. Compare in lowercase + trimmed.
    var norm = opts.map(function(v) { return (v == null ? '' : String(v)).toLowerCase().trim(); });
    return variantsData.find(function(v) {
      if (!v.options) return false;
      for (var i = 0; i < norm.length; i++) {
        var have = (v.options[i] == null ? '' : String(v.options[i])).toLowerCase().trim();
        if (have !== norm[i]) return false;
      }
      return true;
    });
  }

  function resolveCheckout() {
    var size = getSelectedSize();
    var color = getSelectedColor();
    var activeRow = sectionEl.querySelector('.hdt-master-bmsm-bundle-row.active');
    var bundleQty = activeRow ? parseInt(activeRow.getAttribute('data-qty'), 10) : 1;
    if (!bundleQty || bundleQty < 1) bundleQty = 1;

    // 1) Try native bundle-variant match: option3 auto-detected per product (e.g. "1 Pair", "2 Packs", "3 Sets")
    if (size && color) {
      var nativeMatch = findVariantByOptions([size, color, qtyOption(bundleQty)]);
      if (nativeMatch) return { id: nativeMatch.id, quantity: 1 };
    }

    // 2) Fall back to form's current variant id × bundleQty (works for products with no quantity option)
    var form = sectionEl.querySelector('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var fallbackId = idInput && idInput.value ? parseInt(idInput.value, 10) : 0;
    if (fallbackId) return { id: fallbackId, quantity: bundleQty };

    // 3) Last-resort: any variant matching size+color, with bundleQty
    if (size && color) {
      var anyMatch = findVariantByOptions([size, color]);
      if (anyMatch) return { id: anyMatch.id, quantity: bundleQty };
    }

    return null;
  }

  /* ── 1. Checkout ── */
  function isSizeSelected() {
    // True iff the size dropdown button shows a real value (not the "Select size" placeholder).
    // Works for both combined (band+cup) and non-combined size layouts.
    var sizeBtn = sectionEl.querySelector('fieldset.is-style-size .hdt-select');
    if (!sizeBtn) return true;
    var text = sizeBtn.textContent.trim().toLowerCase();
    if (!text || text === 'select size') return false;
    return true;
  }

  function showSizeError(btn) {
    var validation = document.getElementById('master-bmsm-validation-' + sectionId);
    btn.classList.add('error');
    if (validation) validation.classList.add('show');
    setTimeout(function() {
      btn.classList.remove('error');
      if (validation) validation.classList.remove('show');
    }, 3000);
  }

  var checkoutBtn = document.getElementById('master-bmsm-checkout-btn-' + sectionId);
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      var btn = this;
      if (btn.getAttribute('aria-busy') === 'true') return;

      if (!isSizeSelected()) {
        showSizeError(btn);
        return;
      }

      var resolved = resolveCheckout();
      if (!resolved) return;

      btn.setAttribute('aria-busy', 'true');
      var label = btn.querySelector('.hdt-btn-atc_text');
      var originalLabel = label ? label.textContent : 'CHECKOUT';
      if (label) label.textContent = 'PROCESSING...';

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: resolved.id, quantity: resolved.quantity }] })
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.items || data.id) {
            window.location.href = '/checkout';
          } else {
            btn.removeAttribute('aria-busy');
            if (label) label.textContent = originalLabel;
          }
        })
        .catch(function() {
          btn.removeAttribute('aria-busy');
          if (label) label.textContent = originalLabel;
        });
    });
  }

  /* ── 2. Dialog patch (non-modal) ── */
  function patchDialogs() {
    sectionEl.querySelectorAll('.hdt-popover-variant').forEach(function(dialog) {
      if (dialog._bmsmPatched) return;
      dialog._bmsmPatched = true;
      dialog.showModal = function() { if (!this.open) this.show(); };
    });
  }
  patchDialogs();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(patchDialogs).observe(sectionEl, { childList: true, subtree: true });
  }
  document.addEventListener('click', function(e) {
    sectionEl.querySelectorAll('.hdt-popover-variant[open]').forEach(function(dialog) {
      var popover = dialog.closest('hdt-popover');
      var trigger = popover ? popover.previousElementSibling : null;
      if (!dialog.contains(e.target) && e.target !== trigger && (!trigger || !trigger.contains(e.target))) {
        dialog.close();
      }
    });
  });

  /* ── 3. Bundle row selection ── */
  window.selectBundle = function(el, qty) {
    // Scope to THIS section (handles multiple BMSM sections on same page).
    var section = el.closest('.hdt-master-buy-more-save-more-section') || sectionEl;
    section.querySelectorAll('.hdt-master-bmsm-bundle-row').forEach(function(i) {
      i.classList.remove('active');
      var radio = i.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    el.classList.add('active');
    var activeRadio = el.querySelector('input[type="radio"]');
    if (activeRadio) activeRadio.checked = true;
    var form = section.querySelector('form');
    if (form) {
      var qtyEl = form.querySelector('input[name="quantity"]');
      if (qtyEl) qtyEl.value = qty;
    }
  };

  /* ── 4. Product Switcher ── */
  sectionEl.querySelectorAll('.custom-listing-item').forEach(function(item) {
    item.addEventListener('click', function() {
      sectionEl.querySelectorAll('.custom-listing-item').forEach(function(i) { i.classList.remove('cat-active'); });
      sectionEl.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('active'); });
      item.classList.add('cat-active');
      var targetId = item.dataset.target;
      var t = sectionEl.querySelector('#' + targetId);
      if (t) t.classList.add('active');
    });
  });

  /* ── 5. Variant image handler ── */
  var imgScripts = sectionEl.querySelectorAll('script[id^="master-bmsm-variant-images-"]');
  imgScripts.forEach(function(script) {
    var variantImages = {};
    try { variantImages = JSON.parse(script.textContent); } catch (e) {}
    if (Object.keys(variantImages).length === 0) return;

    function updateImages() {
      var selectedOptions = Array.from(sectionEl.querySelectorAll('.hdt-variant-picker input[type="radio"]:checked, .hdt-variant-picker select'))
        .map(function(el) { return el.value.toLowerCase().trim(); });

      var matchedImages = null;
      for (var oi = 0; oi < selectedOptions.length; oi++) {
        if (variantImages[selectedOptions[oi]]) { matchedImages = variantImages[selectedOptions[oi]]; break; }
      }

      /* A block title may instead name a COMBINATION, comma separated:
         "beige, ultra + demi". Every value has to be selected, in any order.
         It overrides the single-value match above because naming two values is
         always the more specific answer, and among combinations the one naming
         the most values wins. Keys holding a single value are skipped here, so
         a section that only lists colours resolves exactly as it did before. */
      var comboSpecificity = 0;
      Object.keys(variantImages).forEach(function(key) {
        var wanted = key.split(',').map(function(value) { return value.trim(); }).filter(Boolean);
        if (wanted.length < 2 || wanted.length <= comboSpecificity) return;

        var allSelected = wanted.every(function(value) {
          return selectedOptions.indexOf(value) !== -1;
        });

        if (allSelected) {
          comboSpecificity = wanted.length;
          matchedImages = variantImages[key];
        }
      });

      sectionEl.querySelectorAll('.hdt-master-bmsm-bundle-row').forEach(function(bundle, index) {
        var variantImg = matchedImages ? matchedImages[index] : null;
        var thumb = bundle.querySelector('.hdt-master-bmsm-bundle-thumb');
        if (!thumb) return;

        var defaultImgs = [null, null, null];
        try { defaultImgs = JSON.parse(bundle.dataset.defaultImages || '[]'); } catch (e) {}

        var qtyBadge = thumb.querySelector('.hdt-master-bmsm-bundle-qty-badge');

        if (variantImg) {
          var stack = thumb.querySelector('.hdt-master-bmsm-bundle-thumb-stack');
          if (stack) stack.remove();
          var imgEl = thumb.querySelector('.hdt-master-bmsm-bundle-img');
          if (imgEl) { imgEl.src = variantImg; imgEl.srcset = variantImg; }
          else {
            var newImg = document.createElement('img');
            newImg.className = 'hdt-master-bmsm-bundle-img';
            newImg.src = variantImg;
            if (qtyBadge) thumb.insertBefore(newImg, qtyBadge); else thumb.appendChild(newImg);
          }
          thumb.style.display = '';
        } else {
          var validDefaults = defaultImgs.filter(function(d) { return d !== null; });
          if (validDefaults.length >= 1) {
            var imgEl2 = thumb.querySelector('.hdt-master-bmsm-bundle-img');
            if (imgEl2) { imgEl2.src = validDefaults[0]; imgEl2.srcset = validDefaults[0]; }
            else {
              var newImg2 = document.createElement('img');
              newImg2.className = 'hdt-master-bmsm-bundle-img';
              newImg2.src = validDefaults[0];
              if (qtyBadge) thumb.insertBefore(newImg2, qtyBadge); else thumb.appendChild(newImg2);
            }
            thumb.style.display = '';
          }
        }
      });
    }

    sectionEl.addEventListener('change', function(e) {
      if (e.target.closest('hdt-variant-picker')) updateImages();
    });
    setTimeout(updateImages, 100);
  });

  /* ── 6. Size label update ── */
  var sizeEquivalents = {
    'AA':'28A, 30A, 32A, 28B, 30B, 28C','A':'34A, 32B, 30C, 28D','B':'36A, 34B, 32C, 30D, 28DD/E',
    'C':'38A, 36B, 34C, 32D, 30DD/E, 28DDD/F','D':'40A, 38B, 36C, 34D, 32DD/E, 30DDD/F, 28G',
    'E':'42A, 40B, 38C, 36D, 34DD/E, 32DDD/F, 30G, 28H','F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F, 32G, 30H, 28I',
    'G':'44B, 42C, 40D, 38DD/E, 36DDD/F, 34G, 32H, 30I, 28J','H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L','J':'44DD/E, 42DDD/F, 40G, 38H, 36I, 34J, 32K, 30L, 28M',
    'K':'44DDD/F, 42G, 40H, 38I, 36J, 34K, 32L, 30M, 28N','L':'44G, 42H, 40I, 38J, 36K, 34L, 32M, 30N, 28O',
    'M':'44H, 42I, 40J, 38K, 36L, 34M, 32N, 30O, 28P','N':'44I, 42J, 40K, 38L, 36M, 34N, 32O, 30P, 28Q',
    'O':'42K, 40L, 38M, 36N, 34O, 32P, 30Q, 28R','P':'42L, 40M, 38N, 36O, 34P, 32Q, 30R',
    'Q':'42M, 40N, 38O, 36P, 34Q, 32R, 30S','R':'44M, 42N, 40O, 38P, 36Q, 34R, 32S, 30T, 28U',
    'A/B':'34A, 32B, 30C, 28D','C/D':'38A, 36B, 34C, 32D, 30DD/E',
    'DD/E/F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F','G/H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I/J/K':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L'
  };
  document.addEventListener('change', function(e) {
    var target = e.target;
    /* Scope to master section only — avoid touching adpbtds / il-lp buttons. */
    if (!target.closest || !target.closest('.hdt-master-buy-more-save-more-section')) return;
    if (target.matches('hdt-richlist') || (target.tagName === 'INPUT' && target.closest('fieldset.is-style-size'))) {
      var fieldset = target.closest('fieldset.is-style-size');
      if (!fieldset) return;
      var val = target.getAttribute('selected') || target.value;
      if (!val) return;
      var labelSpan = fieldset.querySelector('[update-value]');
      if (labelSpan) labelSpan.textContent = val;
      var selectBtn = fieldset.querySelector('button.hdt-select');
      if (selectBtn) {
        var combined = sectionEl.dataset.combinedLayout === 'true';
        var equiv = sizeEquivalents[val];
        selectBtn.textContent = (combined && equiv) ? (val + ' fits bra sizes: ' + equiv) : ('SIZE ' + val);
        checkSelectLineCount(selectBtn);
      }
    }
  });

  /* MutationObserver guard — sibling scripts (e.g. adpbtds-bmsm-v3.js) have global
     change listeners that may overwrite our dropdown button with "X fits bra
     sizes:..." even when our Combined toggle is OFF. Watch the button and revert
     synchronously (microtask, before paint — no visible flicker). */
  function guardButton(btn) {
    if (!btn || btn._masterBmsmGuard) return;
    btn._masterBmsmGuard = true;
    var mo = new MutationObserver(function() {
      var combined = sectionEl.dataset.combinedLayout === 'true';
      if (combined) return;
      var text = btn.textContent || '';
      var m = text.match(/^\s*([A-Z\/]+)\s+fits bra sizes:/i);
      if (m) {
        btn.textContent = 'SIZE ' + m[1];
      }
    });
    mo.observe(btn, { childList: true, characterData: true, subtree: true });
  }
  function guardAllButtons() {
    sectionEl.querySelectorAll('fieldset.is-style-size button.hdt-select').forEach(guardButton);
  }
  guardAllButtons();
  /* Re-guard if Shopify re-renders the variant picker (e.g. on product/variant change). */
  new MutationObserver(guardAllButtons).observe(sectionEl, { childList: true, subtree: true });

  function checkSelectLineCount(btn) {
    if (!btn) return;
    btn.classList.remove('is-oneline');
    var style = getComputedStyle(btn);
    var lineHeight = parseFloat(style.lineHeight) || 22;
    var paddingTop = parseFloat(style.paddingTop) || 0;
    var paddingBottom = parseFloat(style.paddingBottom) || 0;
    var contentHeight = btn.scrollHeight - paddingTop - paddingBottom;
    if (contentHeight <= lineHeight * 1.3) {
      btn.classList.add('is-oneline');
    }
  }

  function initSelectShapes() {
    sectionEl.querySelectorAll('.hdt-master-bmsm-selector-container button.hdt-select').forEach(checkSelectLineCount);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectShapes);
  } else {
    initSelectShapes();
  }
  setTimeout(initSelectShapes, 300);

  /* ── CTA button interceptor ──
     adpbtds-cta-section's button has a hardcoded onclick that scrolls to
     `.hdt-buy-more-save-more-section`. On pages where master is present (and
     adpbtds bmsm is disabled or absent), redirect the scroll target to master.
     We use capture-phase on document so we run before the inline onclick fires;
     stopPropagation prevents the event from reaching the button. */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.hero-button');
    if (!btn) return;
    /* Only intercept if it's the hardcoded adpbtds CTA button (has the onclick string) */
    var onclickStr = btn.getAttribute('onclick') || '';
    if (onclickStr.indexOf('hdt-buy-more-save-more-section') === -1) return;
    /* Only redirect if master section is on this page */
    var master = document.querySelector('.hdt-master-buy-more-save-more-section');
    if (!master) return;
    e.preventDefault();
    e.stopPropagation();
    master.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  /* ── 7. Sync variant ID to form (product-agnostic) ── */
  var formEl = sectionEl.querySelector('form');
  function syncVariantId() {
    if (!formEl) return;
    var idInput = formEl.querySelector('input[name="id"]');
    if (!idInput) return;
    var size = getSelectedSize();
    var color = getSelectedColor();
    if (!size || !color) return;

    // For 3-option products with native qty, prefer the single-pack variant (auto-detected, bundle qty handled separately)
    var match = findVariantByOptions([size, color, qtyOption(1)]);
    if (!match) match = findVariantByOptions([size, color]);
    if (match) idInput.value = match.id;
  }
  sectionEl.addEventListener('change', syncVariantId);
  sectionEl.addEventListener('click', function() { setTimeout(syncVariantId, 100); });
  setTimeout(syncVariantId, 500);

})();
